import { useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "../../utils/Auth";
import Style from "../../components/QrComponents/Style";
import QrFrames from "../../components/QrComponents/QrFrames";
import { useQR } from "../../utils/hooks/useQR";
import { useBack } from "../../utils/hooks/useBack";
import SaveBtn from "../QrEdit/SaveBtn";
import Tabs from "./Tabs";
import { AnimatePresence, motion } from "motion/react";
import { transition, variants } from "./variants";
import styles from "./QrDesign.module.css";

const QrDesign = (props) => {
    const { reference } = props;
    const { fileHandler: { filesReset } } = useAuth();
    const [searchParams] = useSearchParams();
    
    const params = useParams();
    useQR(reference, params?.id || "");
    
    const goBack = useBack();
    const tab = searchParams.get('tab') || 'style';

    const handleBack = () => goBack();

    return (
        <div className={styles.wrapper} >
            <div className={styles.container} >
                <Tabs tab={tab} />
                <AnimatePresence mode="wait">
                    <motion.div
                          key="editor" 
                          className={styles.editor}
                          transition={{...transition, duration: .5}}
                          variants={variants}
                          initial="initial"
                          animate="animate"
                          exit="initial"
                      >
                        <div className={styles.header}>
                            <div className={styles.btnContainer}>
                                <button className={styles.backBtn} onClick={handleBack}><i className="fas fa-arrow-left" style={{pointerEvents: "none"}} />Back</button>
                            </div>
                            <div className={styles.saveBtnContainer}>
                                <SaveBtn reference={reference} ref=""/>
                            </div>
                        </div>
                        <div className={styles.editorInner}>
                            <AnimatePresence mode="wait">
                                {tab === 'frames' ? (
                                    <motion.div
                                        key="frames"
                                        className={styles.motionWrap}
                                        transition={transition}
                                        variants={variants}
                                        initial="initial"
                                        animate="animate"
                                        exit="initial"
                                    >
                                        <QrFrames />
                                    </motion.div>
                                ) : (
                                    <motion.div
                                        key="style"
                                        className={styles.motionWrap}
                                        transition={transition}
                                        variants={variants}
                                        initial="initial"
                                        animate="animate"
                                        exit="initial"
                                    >
                                        <Style />
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                      </motion.div>
                </AnimatePresence>
            </div>
        </div>
    );
};

export default QrDesign;
